<template>
  <div
    class="floating-up"
    :class="{ 'avoid-footer': avoidFooter }"
    @click="scrollToTop"
  >
    <img
      src="@/assets/images/logos/up.png"
      alt="Volver arriba"
      class="up-icon"
    />
  </div>
</template>

<script>
export default {
  name: "ButtonUp",
  data() {
    return {
      avoidFooter: false,
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        this.avoidFooter = entry.isIntersecting;
      },
      {
        root: null,
        threshold: 0.01,
      }
    );

    const footer = document.querySelector("footer");
    if (footer) observer.observe(footer);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.floating-up {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 9999;
  cursor: pointer;
  animation: floatUp 3s ease-in-out infinite;
  transition: bottom 3s ease;
}

/* Evita que se meta en el footer */
.floating-up.avoid-footer {
  bottom: 700px; /* ajustable según la altura del footer */
}

/* Evita solaparse con el footer (móvil) */
@media (max-width: 768px) {
  .floating-up.avoid-footer {
    bottom: 1000px; /* ajústalo al alto de tu footer en móvil */
  }
}

/* Imagen del botón */
.up-icon {
  width: 55px;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

/* Hover opcional */
.floating-up:hover .up-icon {
  transform: scale(1.1);
}

/* Efecto flotante */
@keyframes floatUp {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0px);
  }
}

/* Responsivo */
@media (max-width: 768px) {
  .up-icon {
    width: 45px;
  }
}

@media (max-width: 480px) {
  .up-icon {
    width: 38px;
  }
}
</style>
